import React, { useEffect, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PuffLoader } from 'react-spinners';
import classNames from 'classnames';
import axios from '../axios';
import { AuthContext, Page, Title } from '../shared';
import MainHoc from './MainHoc';
import { ReactComponent as BeeHeroIcon } from '../images/BeeHeroIcon.svg';
import styles from './Main.module.scss';
import PropTypes from 'prop-types';
import { expiredLinkText, titleText, weSentYouAnEmailText } from './textConsts';
import { isMobileQuery } from '../shared/MediaQuery/mediaQueryUtils';
import useMediaQuery from '../shared/hooks/useMediaQuery';
import { ADMIN_API } from '../shared/consts';

const VerifyUser = (props) => {
    const isMobile = useMediaQuery(isMobileQuery);
    const token = props.match.params.token;
    const history = useHistory();
    const { userInfo } = useContext(AuthContext);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [loading, setLoading] = useState(true);

    if (userInfo) {
        history.push('/');
    }

    const handleVerification = async () => {
        try {
            const res = await axios.post(`${ADMIN_API}/verify_registration_user`, {
                verify_user_token: token
            });
            if (res.data?.token_expired) {
                setLoading(false);
                setTokenExpired(true);
            } else if (res.data?.redirect_url) {
                window.location.href = res.data?.redirect_url;
            } else {
                history.push('/');
            }
        } catch (e) {
            history.push('/');
        }
    };

    useEffect(() => {
        !userInfo && handleVerification();
    }, []);

    return (
        <>
            {loading && (
                <div className={styles.verify_loader}>
                    <PuffLoader color={'#ffcc2e'} size={150} />
                </div>
            )}
            {tokenExpired && (
                <MainHoc>
                    <div className={classNames({ [styles.content]: !isMobile })}>
                        <Page noPadding={isMobile}>
                            <Page.Section>
                                <Title flex title={titleText} svg={BeeHeroIcon} iconSize={40} />
                                <div
                                    className={classNames(styles.token_expired, {
                                        [styles.centered]: isMobile
                                    })}
                                >
                                    <div>{expiredLinkText}</div>
                                    <div>{weSentYouAnEmailText}</div>
                                </div>
                            </Page.Section>
                        </Page>
                    </div>
                </MainHoc>
            )}
        </>
    );
};

export default VerifyUser;

VerifyUser.propTypes = {
    match: PropTypes.object,
    location: PropTypes.object
};
